<template>
  <div class="frequency-multiplication-select">
    <el-row class="frequency-multiplication-row">
      倍频选择：
    </el-row>
    <el-row class="frequency-multiplication-row">
      <el-checkbox v-model="OneChecked" @change="Fresh">倍频(1)</el-checkbox>
      <el-input placeholder="              0.5×" :disabled="true" size="mini">
      </el-input>
    </el-row>
    <el-row class="frequency-multiplication-row">
      <el-checkbox v-model="DoubleChecked" @change="Fresh">倍频(2)</el-checkbox>
      <el-input placeholder="              1.0×" :disabled="true" size="mini">
      </el-input>
    </el-row>
    <el-row class="frequency-multiplication-row">
      <el-checkbox v-model="TripleChecked" @change="Fresh">倍频(3)</el-checkbox>
      <el-input placeholder="              2.0×" :disabled="true" size="mini">
      </el-input>
    </el-row>
  </div>
</template>

<script>
    export default {
        name: "FrequencyMultiplicationSelect",
        data() {
            return {
                OneChecked: false,
                DoubleChecked: true,
                TripleChecked: false
            }
        },
        mounted() {
            this.Fresh();
        },
        methods: {
            Fresh() {
                let that = this
                this.$emit("frequencyMultiplication", {
                    OneChecked: that.OneChecked,
                    DoubleChecked: that.DoubleChecked,
                    TripleChecked: that.TripleChecked
                })
            }
        }
    }
</script>

<style lang="scss">
  .frequency-multiplication-select {
    color: white;
    font-size: 15px;
    padding-left: 5px;
    .frequency-multiplication-row {
      padding-left: 10px;
      padding-top: 10px;
      width: 100%;
      .el-checkbox {
        color: white;
      }
      .el-input {
        width: 150px;
        padding-left: 5px;
        padding-right: 5px;
        color: black;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RotatingMachineryThreeDimensionalHolography/FrequencyMultiplicationSelect.vue